module.exports = __webpack_public_path__ + "img/105-transnistria.65d8674b.svg";